import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { TrailerIntervention } from 'shared';
import { FieldsInterventionsPageRequest } from '../fields-interventions-page/fields-interventions-page-request';
import { TrailerInterventionService } from '../../stores/trailer-intervention.service';


@Component({
  selector: 'app-fields-interventions-report',
  templateUrl: './fields-interventions-report.component.html',
  styleUrls: ['./fields-interventions-report.component.scss']
})
export class FieldsInterventionsReportComponent implements OnInit {

  @Input()
  request: FieldsInterventionsPageRequest;

  @Input()
  visible: boolean;

  @Output()
  visibleChange = new EventEmitter<boolean>();

  private _closeSubject = new Subject<void>();
  closed$ = this._closeSubject.asObservable();

  @Input()
  intervention: TrailerIntervention;
  title: string;
  selectedTab: any;
  selectedIndex = 0;
  tabs: any;
  tabsLoading = {};
  loadingVisible: boolean;

  constructor(
    private trailerInterventionService: TrailerInterventionService,
  ) {
    this.close = this.close.bind(this);
    this.selectTab = this.selectTab.bind(this);
  }

  async ngOnInit() {

    this.tabs = [
      {
        id: 1,
        text: 'Rapport',
        load: (data) => {
        }
      },
      {
        id: 2,
        text: 'La Carte',
        load: (data) => {
        }
      }
    ];
  }

  closed(e: any) {
    this.tabsLoading = {};
    this.visibleChange.emit(false);
    this.selectedIndex = 0;
    this._closeSubject.next();
  }

  async onShowing(e: any) {

  }

  onShown(e: any) {
    this.title = `Rapport d'Intervention`;
  }

  close() {
    this.visible = false;
  }

  async selectTab(e: any) {
    // Call load function for tab
    if (e.itemData.hasOwnProperty('load') && !this.tabsLoading.hasOwnProperty(e.itemData.id)) {
      this.loadingVisible = true;
      await e.itemData.load(e.itemData);
      this.loadingVisible = false;
      this.tabsLoading[e.itemData.id] = true;
    }

    this.selectedTab = e.itemIndex;
  }
}
